import { useEffect, useState } from "react";
import API from "../../../services/api";
import "./salary.css";

export default function PendingTeacherSalary() {
  const school = JSON.parse(localStorage.getItem("schoolAdmin"));
  const schoolId = school?.school?.id;

  // Default month = current month
  const today = new Date();
  const currentMonth = `${today.getFullYear()}-${String(
    today.getMonth() + 1
  ).padStart(2, "0")}`;

  const [month, setMonth] = useState(currentMonth);
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);

  // Load when page opens & when month changes
  useEffect(() => {
    loadPending();
  }, [month]);

  const loadPending = async () => {
    try {
      setLoading(true);

      const res = await API.get("/school-admin/salary/pending/", {
        headers: { "X-SCHOOL-ID": schoolId },
        params: { month } // <-- FILTER BY MONTH
      });

      setList(res.data.pending || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const markPaid = async (id) => {
    try {
      await API.post(
        `/school-admin/salary/mark-paid/${id}/`,
        {},
        { headers: { "X-SCHOOL-ID": schoolId } }
      );

      loadPending(); // refresh
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="salary-container">
      <h2 className="page-title">Pending Teacher Salaries</h2>

      {/* MONTH FILTER */}
      <div className="form-box">
        <label>Select Month</label>
        <input
          type="month"
          value={month}
          onChange={(e) => setMonth(e.target.value)}
        />
      </div>

      <table className="salary-table">
        <thead>
          <tr>
            <th>Teacher</th>
            <th>Month</th>
            <th>Amount</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          {loading ? (
            <tr>
              <td colSpan="5" style={{ textAlign: "center" }}>Loading...</td>
            </tr>
          ) : list.length === 0 ? (
            <tr>
              <td colSpan="5" style={{ textAlign: "center" }}>
                No pending salaries for this month
              </td>
            </tr>
          ) : (
            list.map((item) => (
              <tr key={item.id}>
                <td>{item.teacher_name}</td>
                <td>{item.month} {item.year}</td>
                <td>₹{item.salary}</td>
                <td className="pending">Pending</td>
                <td>
                  <button
                    className="btn small primary"
                    onClick={() => markPaid(item.id)}
                  >
                    Mark Paid
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}